/**
 * @generated SignedSource<<d5e3f2b4499adadec491f461408ce9fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type seriesWidgetContent$data = {
  readonly entityId: string;
  readonly seriesContainer: {
    readonly series: ReadonlyArray<{
      readonly __typename: string;
      readonly entityId?: string;
      readonly " $fragmentSpreads": FragmentRefs<"seriesWidgetDisplaySeriesItemResult">;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"contextsSeriesWidgetContextProviderArticle" | "seriesWidgetDisplayArticle">;
  readonly " $fragmentType": "seriesWidgetContent";
};
export type seriesWidgetContent$key = {
  readonly " $data"?: seriesWidgetContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"seriesWidgetContent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "seriesWidgetContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "seriesWidgetDisplayArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contextsSeriesWidgetContextProviderArticle"
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "seriesContainer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "series",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "seriesWidgetDisplaySeriesItemResult"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/)
              ],
              "type": "Base",
              "abstractKey": "__isBase"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};
})();

(node as any).hash = "9c376a4c89835a3ef1941c5fd33f60d6";

export default node;
